import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const bgColor = useColorModeValue('white', 'navy.800');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const headingColor = useColorModeValue('navy.700', 'white');
  const subTextColor = useColorModeValue('gray.600', 'gray.300');
  const cardBg = useColorModeValue('white', 'navy.800');
  const mutedBg = useColorModeValue('gray.50', 'whiteAlpha.50');
  const hoverBg = useColorModeValue('gray.50', 'whiteAlpha.100');

  return {
    bgColor,
    borderColor,
    textColor,
    headingColor,
    subTextColor,
    cardBg,
    mutedBg,
    hoverBg,
  };
};
